var ExperimentSegment = /** @class */ (function () {
    function ExperimentSegment() {
    }
    ExperimentSegment.get = function (experiment, segments) {
        try {
            var segmentString = ExperimentSegment.segmentCache[experiment] || localStorage.getItem(ExperimentSegment.keyPrefix + experiment);
            if (!segmentString) {
                segmentString = segments[ExperimentSegment.generate(1, segments.length) - 1];
                localStorage.setItem(ExperimentSegment.keyPrefix + experiment, segmentString);
            }
            ExperimentSegment.segmentCache[experiment] = segmentString;
            return segmentString;
        }
        catch (e) {
            if (!ExperimentSegment.segmentCache[experiment]) {
                ExperimentSegment.segmentCache[experiment] = segments[ExperimentSegment.generate(1, segments.length) - 1];
            }
            return ExperimentSegment.segmentCache[experiment];
        }
    };
    ExperimentSegment.generate = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    ExperimentSegment.keyPrefix = 'tl-sw-segment-';
    ExperimentSegment.segmentCache = {};
    return ExperimentSegment;
}());
export { ExperimentSegment };
